import {
  FormProps,
  ImageWithFade,
  InputDateRange,
  InputDescription,
  InputFileUpload,
  InputSelect,
  InputText,
} from "@components-common/forms";
import { FC, useEffect, useState } from "react";
import { Assignment } from "./_types";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useField, useFormikContext } from "formik";
import { application } from "../../../_runtime/bootstrap";
import { Col, Loader, Row } from "taltech-styleguide";
import { IconTalTech } from "@components-common/icons";

export const AssignmentFormContent: FC<FormProps<Assignment>> = ({
  groups,
}: any) => {
  const [fieldContents] = useField("contents");
  const [fieldUrl] = useField("picture.url");
  const [imageUrl, setImageUrl] = useState<string>(fieldUrl.value || "");

  useEffect(() => {
    if (fieldContents.value) {
      setImageUrl(fieldContents.value || "");
    }
  }, [fieldContents.value]);

  return (
    <>
      <Col id="courseLogo" xs="12" md="4" lg="4" xl="2">
        <div className={"uploader-wrapper"}>
          <div className={"uploader"}>
            <InputFileUpload text="" />
          </div>
          <div className="img-div">
            {imageUrl !== "" ? (
              <ImageWithFade url={imageUrl} />
            ) : (
              <IconTalTech kind="course" />
            )}
          </div>
        </div>
      </Col>
      <Col md="8" lg="8" xl="10" className="d-flex flex-column gap-2">
        <InputText id="title" elementClass="required" />
        <InputDescription />
        <InputSelect id="groupId" label="Assignment Group" options={groups} />
        <InputDateRange />
      </Col>
    </>
  );
};

export const AssignmentForm: React.FC<any> = ({ ...props }) => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const formik = useFormikContext();
  const { id } = useParams();
  const [groups, setGroups] = useState<any>(undefined);

  useEffect(() => {
    application
      .getHttpClient()
      .get(`/coursesms/groups?courseId=${id}`)
      .then((res: any) => {
        const newGroups = res.body.items.map((group: any) => ({
          value: group.id,
          text: group.name,
        }));
        setGroups([{ value: null, text: "All students" }, ...newGroups]);
      });
  }, []);

  useEffect(() => {
    if (formik.isSubmitting) {
      const values: any = formik.values;
      const data = {
        title: values.title,
        description: values.description,
        state: values.state,
        groupId: values.groupId,
        startDate: values.startDate,
        endDate: values.endDate,
        courseId: id,
      };

      if (formik.isValid) {
        if (props.id === "form_create") {
          application
            .getHttpClient()
            .post("/coursesms/assignments", data)
            .then((res: any) => {
              if (values.fileName !== "") {
                application
                  .getHttpClient()
                  .put(`/coursesms/assignments/${res.body.id}/logo`, {
                    contents: values.contents.replace(
                      "data:image/png;base64,",
                      ""
                    ),
                    fileName: values.fileName,
                  })
                  .then(() => {
                    nav(-1);
                    formik.setSubmitting(false);
                  });
              } else {
                nav(-1);
                formik.setSubmitting(false);
              }
            })
            .catch((e) => {
              formik.setSubmitting(false);
            });
        } else {
          application
            .getHttpClient()
            .put(`/coursesms/assignments/${values.id}`, data)
            .then((res: any) => {
              if (values.contents) {
                application
                  .getHttpClient()
                  .put(`/coursesms/assignments/${values.id}/logo`, {
                    contents: values.contents.replace(
                      "data:image/png;base64,",
                      ""
                    ),
                    fileName: values.fileName,
                  })
                  .then(() => {
                    window.location.replace(pathname.replace("/edit", ""));
                    formik.setSubmitting(false);
                  })
                  .catch((e) => {
                    formik.setSubmitting(false);
                  });
              } else {
                window.location.replace(pathname.replace("/edit", ""));
                formik.setSubmitting(false);
              }
            })
            .catch((e) => {
              formik.setSubmitting(false);
            });
        }
      }
    }
  }, [formik.isSubmitting]);

  return groups === undefined ? (
    <Loader overlay />
  ) : (
    <Row>
      <AssignmentFormContent groups={groups} {...props} />
    </Row>
  );
};
